import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  courtesyReturn: {
    description: 'returnReasonService.courtesyReturn',
    defaultMessage: 'Courtesy Return',
    id: 'aqtBVh',
  },
  orderedWrongItem: {
    description: 'returnReasonService.orderedWrongItem',
    defaultMessage: 'Ordered Wrong Item',
    id: 'RtUTGX',
  },
  warranty: {
    description: 'returnReasonService.warranty',
    defaultMessage: 'Warranty',
    id: 'JgS+y8',
  },
  changedMind: {
    description: 'returnReasonService.changedMind',
    defaultMessage: 'Changed Mind',
    id: 'vt9M8h',
  },
  receivedWrongItem: {
    description: 'returnReasonService.receivedWrongItem',
    defaultMessage: 'Received Wrong Item',
    id: 'WJc442',
  },
  rental: {
    description: 'returnReasonService.rental',
    defaultMessage: 'Rental',
    id: 'mzYdWQ',
  },
  damaged: {
    description: 'returnReasonService.damaged',
    defaultMessage: 'Damaged',
    id: 'p1Ah0k',
  },
  defective: {
    description: 'returnReasonService.defective',
    defaultMessage: 'Defective',
    id: 'qFGRBk',
  },
  arrivedTooLate: {
    description: 'returnReasonService.arrivedTooLate',
    defaultMessage: 'Arrived Too Late',
    id: '3pZfdK',
  },
  missingParts: {
    description: 'returnReasonService.missingParts',
    defaultMessage: 'Missing Parts',
    id: 'oHC57E',
  },
  notAsDescribed: {
    description: 'returnReasonService.notAsDescribed',
    defaultMessage: 'Not As Described',
    id: 'dASBju',
  },
  other: {
    description: 'returnReasonService.other',
    defaultMessage: 'Other',
    id: 'j7WfsC',
  },
  exchange: {
    description: 'returnReasonService.exchange',
    defaultMessage: 'Exchange',
    id: 'mQdaTu',
  },
});

const returnReasonIdToTranslationMap = {
  1: messages.courtesyReturn,
  2: messages.orderedWrongItem,
  3: messages.warranty,
  4: messages.changedMind,
  5: messages.receivedWrongItem,
  6: messages.rental,
  7: messages.damaged,
  8: messages.defective,
  9: messages.arrivedTooLate,
  10: messages.missingParts,
  11: messages.notAsDescribed,
  12: messages.other,
  13: messages.exchange,
};

class ReturnReasonServiceClass {
  hasTranslation(returnReasonId) {
    return !!returnReasonIdToTranslationMap[returnReasonId];
  }

  getTranslation(returnReasonId) {
    return returnReasonIdToTranslationMap[returnReasonId];
  }

  getReturnReasonText({ returnReasonId, name }) {
    if (this.hasTranslation(returnReasonId)) {
      return <FormattedMessage {...this.getTranslation(returnReasonId)} />;
    }
    return name;
  }
}

export const ReturnReasonService = new ReturnReasonServiceClass();
